import React, {Component} from 'react';
import style from '../css/activeBetsResume.css';
// constants
import {VIRTUALS} from '../../../../constants/games';
import {ASSETS_URL} from '../../../../constants/endpoints';
import {
    AMERICAN_FOOTBALL_MODULE,
    BASKETBALL_MODULE,
    FOOTBALL_MODULE,
    RACING_MODULE
} from '../../../../constants/identifiers';
import {BASE_VALUE} from '../../../../constants/chips';
// helpers
import {getFormattedCurrency, getText} from '../../../../helpers/localization';
import {getModuleFromEventType} from '../../../../helpers/moduleHelpers';
import {formatTimeToHHMM} from '../../../../helpers/helperFunctions';
import {
    getAFMarketNameByCode,
    getBasketballMarketNameByCode,
    getFootballMarketNameByCode,
    getRacingMarketNameByCode
} from '../../helpers/marketHelpers';
import {hasEventTypeRacerNumberUI} from '../../modules/racing/helpers/racersHelper';

class ActiveBetsResume extends Component {

    _generateHistoryHeaferRow(eventType) {
        let header = '';
        let racers = '';
        let module = getModuleFromEventType(eventType);

        switch (module) {
            case RACING_MODULE:
                racers = (
                    <div className={`${style.assets} ${style.title}`}>{getText('RACERS', this.props.store)}</div>);
                break;
            default:
                break;
        }
        header = (<div className={`${style.betHistoryRowEven} ${style.title}`}>
            <div className={`${style.dateLocation} ${style.title}`}>{getText('DATE_LOCATION', this.props.store)}</div>
            <div className={`${style.stake} ${style.title}`}>{getText('STAKE', this.props.store)}</div>
            {racers}
            <div
                className={`${style.potentialReturns} ${style.title}`}>{getText('POTENTIAL_RETURNS', this.props.store)}</div>
        </div>);

        return header;
    }

    _generateHistoryRowUI(bet, betIndex, selectionIndex) {
        let marketDetails = this._generateMarketDetails(bet.Channel, bet.EventType, bet.Market.Code, bet.Market.Num, bet.Stake);
        let assets = '';

        if (marketDetails.assets !== '') {
            assets = (<div className={style.assets}>
                <div className={style.innerAssetsContent}>{marketDetails.assets}</div>
            </div>)
        }

        return (<div className={betIndex % 2 === 0
            ? style.betHistoryRowEven
            : style.betHistoryRowOdd} id={`${betIndex}_${bet.Market.Num}`} key={`${betIndex}_${selectionIndex}`}>
            <div className={style.dateLocation}>{`${formatTimeToHHMM(bet.EventTime)} ${bet.Title}`}</div>
            <div
                className={style.stake}>{`${getFormattedCurrency(this.props.store, (bet.Stake / BASE_VALUE).toFixed(2), 2)} ${marketDetails.name}`}</div>
            {assets}
            <div
                className={style.potentialReturns}>{`${getFormattedCurrency(this.props.store, ((bet.Stake * bet.Market.Price) / BASE_VALUE).toFixed(2), 2)}`}</div>
        </div>);
    }

    _generateMarketDetails(gameChannel, eventType, marketCode, marketNum) {
        let module = getModuleFromEventType(eventType);
        let marketName = '';
        let assetsUI = '';

        switch (module) {
            case RACING_MODULE:
                marketName = getText(getRacingMarketNameByCode(marketCode), this.props.store);
                if (marketNum) {
                    marketNum = marketNum.split('-');
                    if (marketNum.length) {
                        assetsUI = marketNum.map((mktNum, index) => {
                            return (<div key={index} id={'simple_bet_racer_silk_' + mktNum}
                                         className={style.marketRacerIconContainer}>
                                {
                                    hasEventTypeRacerNumberUI(eventType)
                                        ? (<div id={'slider_racer_number_' + mktNum}
                                                className={style.racerNumber}>{mktNum}</div>)
                                        : ''
                                }
                                <img
                                    src={`${ASSETS_URL}${VIRTUALS.find((game) => game.channel === gameChannel).URL.BMS_ASSETS}/silks/silk${mktNum}.png`}
                                    className={style.marketRacerIcon} key={index} alt={`icon${mktNum}`}/>
                            </div>);
                        });
                    }
                }

                break;
            case FOOTBALL_MODULE:
                marketName = getText(getFootballMarketNameByCode(marketCode), this.props.store);
                //TODO: what assets do we use for football history ????
                break;
            case BASKETBALL_MODULE:
                marketName = getText(getBasketballMarketNameByCode(marketCode), this.props.store);
                break;
            case AMERICAN_FOOTBALL_MODULE:
                marketName = getText(getAFMarketNameByCode(marketCode), this.props.store);
                break;
            default:
                break;
        }

        return {name: marketName, assets: assetsUI}
    }

    render() {
        let activeBets = this.props.activeBets;
        let header = '';
        let content;

        if (activeBets && activeBets.length > 0) {
            header = this._generateHistoryHeaferRow(activeBets[0].Bets[0].EventType)
            content = activeBets.map((ab, selectionIndex) => ab.Bets.map((bet, betIndex) => this._generateHistoryRowUI(bet, selectionIndex, betIndex)))
        } else {
            content = getText('NO_BETS_RESUME', this.props.store)
        }
        return (<div className={style.activeBetsResume}>
            <div className={style.title}>{getText('BET_SUMMARY', this.props.store)}</div>
            {header}
            {content}
        </div>);
    }
}

export default ActiveBetsResume;



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/sharedComponents/components/activeBetsResume.js